export const moreAbout = [
  {
    title: "A Culinary Odyssey Awaits",
    desc: "Embark on a gastronomic journey with our diverse selection of restaurants. From hidden gems to well-known establishments, we've curated a lineup that promises a symphony of flavors. Whether you crave international cuisine or local favorites, our restaurants are ready to elevate your dining experience. Explore the vibrant tapestry of tastes, each venue a unique chapter in your culinary adventure.",
    buttonTitle: "Restaurants",
    link: "#",
  },
  {
    title: "Ordering Made Effortless",
    desc: "Say goodbye to complexity and hello to simplicity. Our user-friendly ordering process ensures a hassle-free experience. Just a few clicks stand between you and a delectable meal. Choose your favorites, customize to your liking, and hit order – it's that easy. Enjoy the convenience of online ordering at your fingertips.",
    buttonTitle: "Order Now",
    link: "#",
  },
  {
    title: "From Kitchen to Your Doorstep",
    desc: "Relax while we take care of the rest! Our swift and secure delivery service ensures that your order arrives fresh and on time. Track your delivery in real-time, and rest assured that every precaution is taken to maintain the quality of your meal. Experience the joy of effortless dining, delivered straight to your doorstep.",
    buttonTitle: "Make Delivery",
    link: "#",
  },
];
